// Viewer-mode helpers. Lives outside setup.ts so it can be imported
// without pulling Cesium into the static graph — that's what keeps the
// 2D bundle (and the offline PWA precache) Cesium-free.
//
// The resolver itself lives in src/viewer/viewModeBoot.js, which is
// injected into index.html at build time and sets
// `window.__manglilloLowData` before the React bundle runs. We just read
// that single source of truth here.

const LOW_DATA_STORAGE_KEY = 'manglillo.lowDataMode';

declare global {
  interface Window {
    __manglilloLowData?: boolean;
  }
}

export function isLowDataMode(): boolean {
  return window.__manglilloLowData === true;
}

export function setLowDataMode(on: boolean) {
  try {
    localStorage.setItem(LOW_DATA_STORAGE_KEY, on ? '1' : '0');
  } catch {
    // ignore — Safari private browsing can throw.
  }
}
